import styled from 'styled-components';

const StyledImage = styled.img<{ modal: boolean }>`
  width: 100%;
  height: ${(props) => (props.modal ? '100%' : 'calc(200px - 0.25rem)')};
  object-fit: cover;
`;

const StyledMainImage = styled(StyledImage)<{ modal: boolean }>`
  border-radius: ${(props) => props.theme.radius.md} 0 0 ${(props) => props.theme.radius.md};
  height: ${(props) => (props.modal ? '100%' : '400px')};
`;

const StyledImageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;

  & > ${StyledImage}:nth-child(2) {
    border-radius: 0 7px 0 0;
  }

  & > ${StyledImage}:nth-child(4) {
    border-radius: 0 0 7px 0;
  }
`;

export { StyledImage, StyledMainImage, StyledImageGrid };
